// The restrained palette. Everything on the map draws from here.
export const palette = {
  background: 0xf4f1ea,
  land: 0xffffff,
  water: 0xcbdde8,
  waterRim: 0xe0ecf2,
  shoreline: 0xa9c2d0,
  // Terrain hints are washes, never blocks: desaturated and barely there.
  zoneSun: 0xdba33f,
  zoneWind: 0x6fa8b8,
  label: 0xa8a294,
  ink: 0x2b2a27,
  muted: 0x8a867d,
  homeFed: 0xf2b134,
  homeGlow: 0xffd97a,
  homeStarved: 0xe07a5f,
  homeDark: 0x9a958b,
  substation: 0x2b2a27,
  radius: 0x2b2a27,
  thermal: 0x5d6470,
  solar: 0xe0a100,
  wind: 0x3b8ea5,
  hydro: 0x2f6fb0,
  line: 0x2b2a27,
  lineHV: 0x1f6feb,
  fault: 0xd64545,
  night: 0x141a33,
  sun: 0xffc857,
  select: 0x1f6feb,
  bad: 0xd64545,
} as const;

export function plantColor(type: string): number {
  switch (type) {
    case 'solar':
      return palette.solar;
    case 'wind':
      return palette.wind;
    case 'hydro':
      return palette.hydro;
    default:
      return palette.thermal;
  }
}
